// Shared with the matchup report builder, so a score or record reads the same
// in a computed fact as anywhere else on the page.
export { formatPoints, formatRecord } from "@averagejoesff/shared";

/** Margin with a leading "+", two decimals. */
export function formatMargin(margin: number): string {
  return `+${margin.toFixed(2)}`;
}

/** Whole-dollar amount, e.g. "$50" — every payout amount is a round figure. */
export function formatCurrency(amount: number): string {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  }).format(amount);
}

export function formatGeneratedAt(iso: string): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return iso;
  return date.toLocaleString(undefined, {
    dateStyle: "medium",
    timeStyle: "short",
  });
}

/** 1 → "1st", 2 → "2nd", 11 → "11th", 22 → "22nd". */
export function formatOrdinal(n: number): string {
  const lastTwo = n % 100;
  if (lastTwo >= 11 && lastTwo <= 13) return `${n}th`;
  const suffixes: Record<number, string> = { 1: "st", 2: "nd", 3: "rd" };
  const suffix = suffixes[n % 10] ?? "th";
  return `${n}${suffix}`;
}

/**
 * A chance of 0 to 1 as a whole percent. The ends read "<1%" and ">99%" rather
 * than 0 and 100, since a simulation can't prove either; only when no games are
 * left (`settled`) is "In" or "Out" true.
 */
export function formatOdds(chance: number, settled = false): string {
  if (settled && chance === 1) return "In";
  if (settled && chance === 0) return "Out";
  if (chance < 0.005) return "<1%";
  if (chance > 0.995) return ">99%";
  return `${Math.round(chance * 100)}%`;
}
